import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Row,
    Col,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock,
    Radio
} from 'react-bootstrap';
import { isNullOrEmpty } from '../../../utils/utilities';
import { copy } from '../../../users/constants';

import * as actions from '../../../actions/adminActions';
import { Alert } from '../../../alerts';
import * as alertActions from '../../../alerts/actions';
import { getCurrentSession } from '../../../../lib/authentication'

const TEMP_UNDERWRITER_BROKER_ID = '220bcd0c-bf6e-4189-98b6-fada97d30633';

export class EditUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdmin:
                this.props.selectedUser && this.props.selectedUser.role.includes('admin')
                    ? 'true'
                    : 'false',
            firstName: props.selectedUser.firstName || '',
            lastName: props.selectedUser.lastName || '',
            jobTitle: props.selectedUser.title || '',
            phoneExt: props.selectedUser.phoneExt || '',
            phone: props.selectedUser.phone || ''
        };
        this.onChangeAdmin = this.onChangeAdmin.bind(this);
        this.submitEditUser = this.submitEditUser.bind(this);
    }

    onChangeAdmin(event) {
        this.setState({
            ...this.state,
            isAdmin: event.target.value
        });
    }

    computeUserRole(selectedUser, isAdmin) {
        let userRoleParts = selectedUser.role.split(':');
        let userType = userRoleParts[0];
        let brokerId = selectedUser.brokerId;
        let brokerIdIsUndefined = typeof brokerId === 'undefined';

        switch (userType) {
            case 'broker':
                return isAdmin ? 'broker:admin' : 'broker';
            case 'underwriter':
                return isAdmin ? 'underwriter:admin' : 'underwriter';
            case 'admin':
                if (brokerIdIsUndefined || brokerId === TEMP_UNDERWRITER_BROKER_ID) {
                    return isAdmin ? 'underwriter:admin' : 'underwriter';
                }
                return isAdmin ? 'broker:admin' : 'broker';
            case 'user':
                if (brokerIdIsUndefined || brokerId === TEMP_UNDERWRITER_BROKER_ID) {
                    return isAdmin ? 'underwriter:admin' : 'underwriter';
                }
                return isAdmin ? 'broker:admin' : 'broker';
            default:
                let newRole = isAdmin ? 'underwriter:admin' : 'underwriter';
                console.warn(
                    `Unexpected userType ${userType} found for user ${
                    selectedUser.id
                    }! Converting to `
                );
                return newRole;
        }
    }

    submitEditUser(event) {
        const { id, username } = this.props.selectedUser;
        event.preventDefault();
        if (this.state.errorStatus) return;
        if (
            isNullOrEmpty(this.state.firstName) ||
            isNullOrEmpty(this.state.lastName) ||
            isNullOrEmpty(this.state.phone)
        )
            return;
        const paramsArray = [
            { fieldName: 'firstName', fieldValue: this.state.firstName },
            { fieldName: 'lastName', fieldValue: this.state.lastName },
            {
                fieldName: 'title',
                fieldValue: isNullOrEmpty(this.state.jobTitle) ? ' ' : this.state.jobTitle
            },
            { fieldName: 'phone', fieldValue: this.state.phone },
            {
                fieldName: 'phoneExt',
                fieldValue: isNullOrEmpty(this.state.phoneExt) ? ' ' : this.state.phoneExt
            }
        ];

        const userRole = this.computeUserRole(
            this.props.selectedUser,
            this.state.isAdmin === 'true'
        );
        getCurrentSession()
            .then((result) => {
                const { idToken } = result;
                return apigClient.adminUsersIdPut(
                    { id },
                    [...paramsArray,
                    {
                        fieldName: 'role',
                        fieldValue: userRole
                    }
                    ],
                    {
                        headers: {
                            Authorization: idToken
                        }
                    })
            }).then(result2 => {
                if (result2.data && result2.data.success === true) {
                    this.props.dispatch(
                        alertActions.setAlert(new Alert('success', `The profile for ${this.props.selectedUser.username} has been updated`, true))
                    );
                    this.props.dispatch(actions.getUsersByBrokerage(this.props.loggedInUser));
                    return this.props.hideEditModal();
                } else {
                    this.props.dispatch(alertActions.setAlert(new Alert('warning', `There was an error editing the user (${username}). Please contact support!`, true)));
                    return this.props.hideEditModal();
                }
            }).catch(e => {
                if (e instanceof Error) {
                    console.log(e.message);
                }
            });
    }

    render() {
        if (this.props.selectedUser === null || !this.props.selectedUser.id) {
            return (
                <div className="editUserModal">
                    <h3>
                        There was an error with the Edit Modal. Please contact support for
                        assistance
                    </h3>
                </div>
            );
        }

        // todo: move these from render
        const validateFirstName = e => {
            return this.setState({
                ...this.state,
                errorStatus: isNullOrEmpty(e.target.value) ? true : false,
                firstName: e.target.value
            });
        };
        const validateLastName = e => {
            return this.setState({
                ...this.state,
                errorStatus: isNullOrEmpty(e.target.value) ? true : false,
                lastName: e.target.value
            });
        };
        const validateJobTitle = e => {
            return this.setState({ ...this.state, errorStatus: false, jobTitle: e.target.value });
        };
        const validatePhone = e => {
            return this.setState({
                ...this.state,
                errorStatus: isNullOrEmpty(e.target.value) ? true : false,
                phone: e.target.value
            });
        };
        const validatePhoneExt = e => {
            return this.setState({ ...this.state, errorStatus: false, phoneExt: e.target.value });
        };

        const { firstName, lastName, phone } = this.state;

        const helpBlock = (text, helpClass) => {
            return <HelpBlock className={`${helpClass}`}>{text}</HelpBlock>;
        };

        const { email } = this.props.selectedUser;

        return (
            <div className="editUserModal">
                <p>Email:</p>
                <h4>{email}</h4>

                <p className="editAdminText">Is user an admin?</p>
                <form onSubmit={this.submitEditUser}>
                    <FormGroup>
                        <br />
                        <Radio
                            name="radioGroup"
                            className="editAdminInput"
                            inline
                            required
                            onChange={this.onChangeAdmin}
                            value={'true'}
                            checked={this.state.isAdmin == 'true'}
                            disabled={this.props.selectedUser.id === this.props.user.id}
                        >
                            Yes
                        </Radio>{' '}
                        <Radio
                            name="radioGroup"
                            className="editAdminInput"
                            inline
                            required
                            onChange={this.onChangeAdmin}
                            value={'false'}
                            checked={this.state.isAdmin == 'false'}
                            disabled={this.props.selectedUser.id === this.props.user.id}
                        >
                            No
                        </Radio>
                    </FormGroup>

                    <Row>
                        <Col xs={12} sm={8} md={8} lg={10}>
                            <p className="adminEditAddInfo">
                                {copy.lang('underwritersEditUserGroupTip')}
                            </p>
                        </Col>
                    </Row>

                    <FormGroup controlId="firstName">
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl
                            id="firstName"
                            type="text"
                            label="Text"
                            value={this.state.firstName}
                            onChange={validateFirstName}
                            ref="firstName"
                        />
                        {firstName.length === 0 ? (
                            helpBlock('*Required', 'helpBlockRed')
                        ) : (
                                <div className="completeSpace" />
                            )}
                    </FormGroup>
                    <FormGroup controlId="lastName">
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl
                            id="lastName"
                            type="text"
                            label="Text"
                            value={this.state.lastName}
                            onChange={validateLastName}
                        />
                        {lastName.length === 0 ? (
                            helpBlock('*Required', 'helpBlockRed')
                        ) : (
                                <div className="completeSpace" />
                            )}
                    </FormGroup>
                    <FormGroup controlId="jobTitle">
                        <ControlLabel>Job Title</ControlLabel>
                        <FormControl
                            id="jobTitle"
                            type="text"
                            label="Text"
                            placeholder="optional"
                            value={this.state.jobTitle}
                            onChange={validateJobTitle}
                        />
                        <div className="completeSpace" />
                    </FormGroup>
                    <Row>
                        <Col xs={8} sm={8} md={8} lg={8}>
                            <FormGroup controlId="phone">
                                <ControlLabel>Phone Number</ControlLabel>
                                <FormControl
                                    id="phone"
                                    type="text"
                                    label="Text"
                                    value={this.state.phone}
                                    onChange={validatePhone}
                                />
                                {phone.length === 0 ? (
                                    helpBlock('*Required', 'helpBlockRed')
                                ) : (
                                        <div className="completeSpace" />
                                    )}
                            </FormGroup>
                        </Col>
                        <Col xs={4} sm={4} md={4} lg={4}>
                            <FormGroup controlId="phoneExt">
                                <ControlLabel>Ext</ControlLabel>
                                <FormControl
                                    id="phoneExt"
                                    type="text"
                                    label="Text"
                                    placeholder="optional"
                                    value={this.state.phoneExt}
                                    onChange={validatePhoneExt}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button className="saveEditChanges" type="submit">
                        Save Changes
                    </Button>
                    <Button
                        className="cancelEdit secondary"
                        onClick={() => {
                            return this.props.hideEditModal();
                        }}
                    >
                        Cancel
                    </Button>
                </form>
            </div>
        );
    }
}

EditUserModal.propTypes = {
    hideEditModal: PropTypes.func,
    getUsersByBrokerage: PropTypes.func,
    selectedUser: PropTypes.object,
    loggedInUser: PropTypes.object
};

export default connect(state => {
    return {
        user: state.user
    };
})(EditUserModal);
